import React from 'react';

import { AvailabilitySearchErrorCard } from './AvailabilitySearchErrorCard.component';

export const RateCodeUnavailableCard = () => {
  return (
    <AvailabilitySearchErrorCard description="Sorry, there are no rooms available for your code on those dates. Please try another search or see our normal rates below." />
  );
};
